import service from "@/api/request";
export const getMediaGroups = (type = 1) => service.getByQuery(`/courseAdmin/video/groupList?type=${type}`);
export const editMediaGroup = (id, name) => service.postByQs("/courseAdmin/video/editGroup", {
    name,
    groupId: id,
});
export const addMediaGroup = (name, type = 1) => service.postByQs("/courseAdmin/video/addGroup", { name, type });
export const deleteMediaGroup = (id) => service.postByForm(`/courseAdmin/video/deleteGroup?groupId=${id}`, "");
export const getMediaList = (data) => service.getByParams(`/courseAdmin/video/videoList`, data);
export const getPlayerUrl = (id) => service.getByQuery(`/courseAdmin/video/getPlayUrl?videoId=${id}`);
export const deleteAudio = (id) => service.postByForm(`/courseAdmin/video/offlineById?id=${id}`, "");
export const getAudioData = (id) => service.getByQuery(`/courseAdmin/video/selectAudio?audioId=${id}`);
export const uploadAudioCover = (file, { token, ssoId }) => {
    const data = new FormData();
    data.append("zt_token", token);
    data.append("businessType", "audio");
    data.append("fileType", "cover");
    data.append("file", file);
    return service.postByForm("/courseAdmin/file/uploadFile", data, {
        sso_sessionid: ssoId,
    });
};
export const uploadAudioCourseware = (file, { token, ssoId }) => {
    const data = new FormData();
    data.append("zt_token", token);
    data.append("businessType", "audio");
    data.append("fileType", "courseware");
    data.append("file", file);
    return service.postByForm("/courseAdmin/file/uploadFile", data, {
        sso_sessionid: ssoId,
    });
};
export const uploadFile = (data, ssoId) => {
    return service.postByForm("/courseAdmin/file/uploadFile", data, {
        sso_sessionid: ssoId,
    });
};
export const saveAudio = (data) => service.postByJson("/courseAdmin/video/saveAudio", data);
// export const initUploadAccessInfo = (name: string) =>
//   service.getByQuery(
//     `/courseAdmin/video/initUploadAccessInfo?title=${name}&fileName=${name}`
//   );
export const initUploadAccessInfo = (name) => service.getByParams('/courseAdmin/video/initUploadAccessInfo', {
    title: name,
    fileName: name
});
export const refreshUploadAccessInfo = (id) => service.getByQuery(`/courseAdmin/video/refreshUploadAccessInfo?videoId=${id}`);
export const getVideoData = (id) => service.getByQuery(`/courseAdmin/video/selectVideo?videoId=${id}`);
export const saveVideo = (data) => service.postByJson("/courseAdmin/video/saveVideo", data);
export const getGraphocList = (data) => service.getByParams(`/courseAdmin/graphic/page`, data);
export const changeGraphicStatus = (data) => service.postByJson(`/courseAdmin/graphic/changeStatus`, data);
export const getGraphicInfo = (id) => service.getByQuery(`/courseAdmin/graphic/get?id=${id}`);
export const saveGraphic = (data) => service.postByJson(`/courseAdmin/graphic/saveOrUpdate`, data);
